import { Box, Button, InputAdornment, TextField, Typography } from "@mui/material";
import { COLOR } from "../../../utils/colors";
import { VIEW } from "../../../utils/breakpoint";
import { AddOutlined } from "@mui/icons-material";
import { useState } from "react";
import { GridSearchIcon } from "@mui/x-data-grid";
import LayoutMapTable from "./_components/layout-map-table";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MapType } from "../../../hooks/map.type";

export default function BuildingLayoutMaps({
  id,
  onCreateNew,
  onNext,
  onEdit
}: {
  id: string,
  onCreateNew?: () => void
  onNext?: (selectedFloorMaps: MapType[]) => void,
  onEdit?: (mapId: string) => void,
}) {
  const [searchTerm, setSearchTerm] = useState('')
  const [isNextDisabled, setIsNextDisabled] = useState(true)
  const [selectedFloorMaps, setSelectedFloorMaps] = useState<MapType[]>([])
  const navigate = useNavigate()

  const onDataUpdate = (maps: MapType[]) => {
    setSelectedFloorMaps(maps)
    setIsNextDisabled(maps.length <= 0)
  }

  const onHandleEdit = (mapId: string) => {
    onEdit?.(mapId)
  }
  const onHandleNext = () => {
    onNext?.(selectedFloorMaps)
  }
  return (
    <Box sx={(theme) => ({
      paddingY: '34px',
      color: COLOR.neutral[900],
      [theme.breakpoints.up(VIEW.PHONE)]: {
        paddingX: '24px',
      },
      [theme.breakpoints.up(VIEW.TABLET)]: {
        paddingX: '44px',
      }
    })}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              sx={{
                fontSize: '24px',
                fontWeight: 600,
                color: COLOR.neutral[900]
              }}
            >
              Layout Maps
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 400,
                color: COLOR.neutral[900],
                opacity: 0.6,
              }}
            >
              Select the layout maps for the building
            </Typography>
          </Box>
          <Button onClick={() => onCreateNew?.()} variant="outlined" startIcon={<AddOutlined />}>
            Create New
          </Button>
        </Box>
        <Box sx={{ display: 'flex', mt: '20px' }}>
          <TextField
            id="search-store-name"
            variant="outlined"
            size="small"
            placeholder='Search Maps'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              flex: 'auto',
              backgroundColor: 'white',
              height: "40px",
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <GridSearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>
      <LayoutMapTable
        search={searchTerm}
        onUpdateData={(map) => onDataUpdate(map)}
        onEdit={onHandleEdit}
      />
      <Box sx={{ display: 'flex', justifyContent: 'end' }}>
        <Button onClick={onHandleNext} variant="contained" disabled={isNextDisabled}>Next</Button>
      </Box>
    </Box>
  )
}